
import {
    AppBar,
    Toolbar,
    Button,
    Box,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Divider,
} from "@mui/material";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

import { useState } from "react";
import { useNavigate } from "react-router-dom";

const menu = [
    { label: "Inicio", id: "inicio" },
    { label: "Quiénes Somos", id: "quienes-somos" },
    { label: "Misión", id: "mision" },
    { label: "Servicios", id: "servicios" },
    { label: "Simuladores", id: "simuladores" },
    { label: "Presentes", id: "presentes" },
    { label: "Contacto", id: "contacto" },
];

const Navbar = () => {
    const navigate = useNavigate();

    const [menuOpen, setMenuOpen] = useState(false);

    const goToSection = (id) => {
        setMenuOpen(false);

        setTimeout(() => {
            document.getElementById(id)?.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }, 100);
    };

    const iniciarSesion = () => {
        setMenuOpen(false);
        navigate("/ahorrador-login");
    };

    return (
        <>
            <AppBar
                position="fixed"
                elevation={0}
                sx={{
                    background: "rgba(255,255,255,.85)",
                    backdropFilter: "blur(10px)",
                    color: "#517950",
                    zIndex: 1200,
                }}
            >
                <Toolbar
                    sx={{
                        justifyContent: "space-between",
                        minHeight: {
                            xs: 64,
                            md: 72,
                        },
                        px: {
                            xs: 2,
                            sm: 3,
                            md: 5,
                        },
                    }}
                >
                    {/* Nombre / logo */}
                    <Box
                        sx={{
                            fontWeight: 800,
                            fontSize: {
                                xs: 20,
                                sm: 22,
                                md: 24,
                            },
                            color: "#517950",
                            cursor: "pointer",
                        }}
                        onClick={() => goToSection("inicio")}
                    >
                        Ready Cash
                    </Box>

                    {/* ========================= */}
                    {/* DESKTOP */}
                    {/* ========================= */}

                    <Box
                        sx={{
                            display: {
                                xs: "none",
                                md: "flex",
                            },
                            alignItems: "center",
                            gap: 1,
                        }}
                    >
                        {menu.map((item) => (
                            <Button
                                key={item.id}
                                color="inherit"
                                onClick={() => goToSection(item.id)}
                                sx={{
                                    fontWeight: 500,
                                    textTransform: "none",
                                    fontSize: 15,
                                }}
                            >
                                {item.label}
                            </Button>
                        ))}

                        <Button
                            onClick={iniciarSesion}
                            startIcon={
                                <AccountCircleOutlinedIcon />
                            }
                            sx={{
                                ml: 1,
                                px: 2.5,
                                py: 1,
                                borderRadius: "30px",
                                backgroundColor: "#517950",
                                color: "#fff",
                                fontWeight: 500,
                                textTransform: "none",
                                border: "1px solid #d6b85a",
                                boxShadow:
                                    "0 4px 12px rgba(81, 121, 80, 0.18)",
                                transition: "all 0.3s ease",

                                "&:hover": {
                                    backgroundColor: "#fff",
                                    color: "#517950",
                                    borderColor: "#517950",
                                    transform: "translateY(-2px)",
                                    boxShadow:
                                        "0 6px 16px rgba(81, 121, 80, 0.25)",
                                },

                                "& .MuiButton-startIcon": {
                                    marginRight: 0.8,
                                },
                            }}
                        >
                            Clientes
                        </Button>
                    </Box>

                    {/* ========================= */}
                    {/* MOBILE */}
                    {/* ========================= */}

                    <IconButton
                        onClick={() => setMenuOpen(true)}
                        sx={{
                            display: {
                                xs: "flex",
                                md: "none",
                            },
                            color: "#517950",
                        }}
                        aria-label="Abrir menú"
                    >
                        <MenuIcon fontSize="large" />
                    </IconButton>
                </Toolbar>
            </AppBar>

            {/* ========================= */}
            {/* DRAWER MOBILE */}
            {/* ========================= */}

            <Drawer
                anchor="right"
                open={menuOpen}
                onClose={() => setMenuOpen(false)}
                sx={{
                    display: {
                        xs: "block",
                        md: "none",
                    },
                }}
            >
                <Box
                    sx={{
                        width: {
                            xs: "80vw",
                            sm: 350,
                        },
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                    }}
                    role="presentation"
                >
                    {/* Header del menú */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            px: 2.5,
                            py: 2,
                            color: "#517950",
                        }}
                    >
                        <Box
                            sx={{
                                fontWeight: 800,
                                fontSize: 21,
                            }}
                        >
                            Ready Cash
                        </Box>

                        <IconButton
                            onClick={() => setMenuOpen(false)}
                            sx={{
                                color: "#517950",
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Divider />

                    {/* Links */}
                    <List
                        sx={{
                            px: 1.5,
                            py: 2,
                        }}
                    >
                        {menu.map((item) => (
                            <ListItem
                                key={item.id}
                                disablePadding
                                sx={{
                                    mb: 0.5,
                                }}
                            >
                                <ListItemButton
                                    onClick={() =>
                                        goToSection(item.id)
                                    }
                                    sx={{
                                        borderRadius: 2,
                                        color: "#517950",

                                        "&:hover": {
                                            backgroundColor:
                                                "rgba(81,121,80,.08)",
                                        },
                                    }}
                                >
                                    <ListItemText
                                        primary={item.label}
                                        slotProps={{
                                            primary: {
                                                fontWeight: 500,
                                            },
                                        }}
                                    />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>

                    <Box sx={{ mt: "auto", p: 2.5 }}>
                        <Button
                            fullWidth
                            onClick={iniciarSesion}
                            startIcon={
                                <AccountCircleOutlinedIcon />
                            }
                            sx={{
                                py: 1.3,
                                borderRadius: "30px",
                                backgroundColor: "#517950",
                                color: "#fff",
                                fontWeight: 600,
                                textTransform: "none",
                                border: "1px solid #d6b85a",

                                "&:hover": {
                                    backgroundColor: "#fff",
                                    color: "#517950",
                                    borderColor: "#517950",
                                },
                            }}
                        >
                            Clientes
                        </Button>
                    </Box>
                </Box>
            </Drawer>
        </>
    );
};

export default Navbar;

